const initialState = {
  loading: false,
  success: false,
  error: null,
  data: null,
};

const AddUserMangFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SUBMIT_USER_FORM_REQUEST":
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

   case "SUBMIT_USER_FORM_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload,
        error: null,
      };

    case "SUBMIT_USER_FORM_ERROR":
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default AddUserMangFormReducer;
